import { FC } from "react";
import { FolderItem } from "./folder-item";
import { FileItem } from "./file-item";
import style from "../style.module.scss";
import { ContentProps } from "../../types";
import { SortLabel } from "./sort-label";

export const Table: FC<ContentProps> = (props) => {
  const { fileList, folderList, ...actions } = props;
  return (
    <div className={style.container}>
      <div className={style.grid}>
        <SortLabel text="Nome" propertyBinded="name" />
        <SortLabel text="Data caricamento" propertyBinded="creationDate" />
        <SortLabel text="Dimensione" propertyBinded="dimension" />
        <div />
      </div>
      {folderList &&
        folderList.map((folder, index) => (
          <FolderItem key={index} item={folder} {...actions} />
        ))}
      {fileList &&
        fileList.map((file, index) => (
          <FileItem
            key={index}
            item={file}
            moveFileActionAllowed={Boolean(folderList?.length)}
            {...actions}
          />
        ))}
    </div>
  );
};
